/* eslint-disable no-unused-vars */
import React from "react";

interface GetCookie {
  matches: RegExpMatchArray | null;
}

export default function getCookie(key: string): GetCookie {
  const matches = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
  return { matches };
}
